import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import { PermissionProducts } from "~pages/Users/enums/permissionProducts.ts";
import type { DefaultOperationSuccessResponse } from "~types/response";

type UserData = {
  userId: number;
  isPendingUser: boolean;
  selectedProduct: string;
};

const useInviteNotifyUser = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, UserData>({
    mutationFn: async ({ userId, isPendingUser, selectedProduct }) => {
      const url = `${sport}/o/${organizationId}/users/${userId}/${isPendingUser ? "invite" : "notify"}`;
      return await request(url, { method: "POST", body: { isForTeamManagerProduct: selectedProduct === PermissionProducts.TeamManager } });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, { isPendingUser }) => {
      if (response?.data?.[0]?.success) {
        notification.success({
          message: formatMessage({
            id: `permissions.user.actions.${isPendingUser ? "invite" : "notify"}.success`,
          }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useInviteNotifyUser;
